function getCleanedString(str){
  // Definimos los caracteres que queremos eliminar
  var specialChars = "!@#$^&%*()+=[]\/{}|:<>¿?,.";

  // Los eliminamos todos
  for (var i = 0; i < specialChars.length; i++) {
    str= str.replace(new RegExp("\\" + specialChars[i], 'gi'), '');
  }
  
  // Quitamos acentos y "ñ"
  str = str.replace(/á/gi,"a");
  str = str.replace(/é/gi,"e");
  str = str.replace(/í/gi,"i");
  str = str.replace(/ó/gi,"o");
  str = str.replace(/ú/gi,"u");
  str = str.replace(/ñ/gi,"n");

  return str;
}